import styled from 'styled-components'

export const BreadcrumbsListStyled = styled.ol`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  list-style: none;
  padding: 0;
  margin: 0;
`
